import axios from 'axios'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { AiFillCheckCircle } from 'react-icons/ai'
import {
  BsBag,
  BsCashCoin,
  BsGraphUp,
  BsHandbagFill,
  BsPersonFill,
  BsThreeDots,
} from 'react-icons/bs'
import { CgFileDocument } from 'react-icons/cg'
import { FaCashRegister, FaShoppingBag } from 'react-icons/fa'
import { FiMinus } from 'react-icons/fi'
import { HiAdjustments, HiDocumentText, HiShoppingBag } from 'react-icons/hi'
import { IoMdAdd } from 'react-icons/io'
import {
  IoBarChartSharp,
  IoCalendar,
  IoCashSharp,
  IoDocuments,
  IoPersonAddSharp,
  IoWallet,
} from 'react-icons/io5'
import { SiGraphql } from 'react-icons/si'
import {
  Area,
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ComposedChart,
  LabelList,
  Legend,
  Line,
  LineChart,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import FloatingMenu from '../components/Display/FloatingMenu'
import Switch from '../components/Inputs/Switch'
import { formatPipe, getDenomination } from '../utils/utils'
import './DashboardStats.css'
import { toFixed } from 'accounting'
import { FloatingMenuContext } from '../context/FloatingMenuContext'
import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import Modal from '../components/Display/Modal'
import { DashboardStatsClass } from './DashboardClass'
import { ThemeContext } from '../context/ThemeContext'
import { getJsonFromS3 } from '../utils/UploadFile'
import { useHistory } from 'react-router'
import { BiMoney } from 'react-icons/bi'
import useSnackBars from '../hooks/SnackbarConsumerHook'

const server = process.env.REACT_APP_SERVER_URL

const DashboardStats = ({ isFirstRender, setIsFirstRender }: { isFirstRender: boolean, setIsFirstRender: (isFirstRender: boolean) => void }) => {
  console.log(" DashboardStats")
  const div7RefContainer = useRef<any>()
  const div8Ref = useRef<any>()

  const [stats, setStats] = useState<IStats | null>(null)

  const [windowSize, setWindowSize] = useState(getWindowSize())

  const [category, setCategory] = useState<any[]>([])

  const [salesInformation, setSalesInformation] = useState<any[]>([])

  const [selectedCard, setSelectedCard] = useState<number | null>(null)

  const { onClick, onChangeSelected, cardStates, selectedValue } = useContext(
    FloatingMenuContext
  )

  const { theme } = useContext(ThemeContext)

  const user = useSelector((state: RootState) => state?.auth?.user)

  const [showAccounts, setShowAccounts] = useState<boolean>(false)

  const [isServicesSelected, setIsServicesSelected] = useState<boolean>(false)

  const [infoAccount, setInfoAccount] = useState<any | null>(null)

  const { addAlert } = useSnackBars()

  const history = useHistory()

  let objTransform = {
    1: 'Enero',
    2: 'Febrero',
    3: 'Marzo',
    4: 'Abril',
    5: 'Mayo',
    6: 'Junio',
    7: 'Julio',
    8: 'Agosto',
    9: 'Septiembre',
    10: 'Octubre',
    11: 'Noviembre',
    12: 'Diciembre',
  }

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  useEffect(() => {
    // console.log("ver el height", div7RefContainer?.current?.offsetHeight)
  }, [div7RefContainer])


  useEffect(() => {
    if (user) {
      if (
        user['custom:user_role'] === 'cashier' ||
        user['custom:user_role'] === 'admin'
      ) {
        history.push('/dashboard/modulo_ventas/ventas')
      }
    }
  }, [user])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const getInfoAccount = async () => {
    let response = await axios.get(`${server}/user/tenant`)
    setInfoAccount(response?.data?.tenant)
  }

  useEffect(() => {
    // if (!isFirstRender) {
      getInfoAccount()
    // }
  }, [])

  const onSetSalesByMonth = (response) => {
    // response.sales.salesByMonth = [
    //   { bsTotal: '1500.00', month: 1, usdTotal: '900.20' },
    //   ...response.sales.salesByMonth,
    // ]

    let sales = response.sales.salesByMonth.map((v) => ({
      ...v,
      [objTransform[v.month]]: +v.bsTotal,
      month: objTransform[v.month],
    }))

    setSalesInformation(sales)
  }

  const onSetCategory = (response) => {
    let categoryLocal = response.inventory.categories.slice(0, 3)

    let otherCategories = response.inventory.categories.slice(3)

    let otherCategoriesSum = +toFixed(
      otherCategories.reduce(
        (a, b) => +toFixed(a, 2) + +toFixed(b.percentage, 2),
        0
      ),
      2
    )

    if (otherCategories.length === 0) {
      setCategory(categoryLocal)
    } else {
      setCategory([
        ...categoryLocal,
        { name: 'Otros', percentage: otherCategoriesSum },
      ])
    }
  }

  const getStats = async () => {
    // try {
    //   let re = await getJsonFromS3(user['custom:tenant_id'])
    //   console.log("RESPONSE", re)
    // } catch (err) {
    //   console.log("RESPONSE 2", err)
    // }

    // let res = await fetch(
    //   'https://nevula-docs-bucket-test-12db7f23c30b.s3.amazonaws.com/123bdsahv/DashboardStats.json'
    // )
    let response: IStats | null = null
    try {
      response = await getJsonFromS3(user['custom:tenant_id'])
      // addAlert({
      //   message: 'Error al cargar las estadísticas',
      //   status: 'error'
      // })
    } catch (err) {
      let dashboardStats = new DashboardStatsClass()
      setStats(dashboardStats)
    }
    if (response) {
      // setStats({...response, monthIncome: {
      //   usdAmount: "20",
      //   bsAmount: "50"
      // }} )

      onSetSalesByMonth(response)

      // response.inventory.categories = [
      //   { name: 'Salsa', percentage: 10, totalQty: '2' },
      //   { name: 'Carne', percentage: 5, totalQty: '2' },
      //   { name: 'Atun', percentage: 10, totalQty: '2' },
      //   { name: 'Pollo', percentage: 10, totalQty: '2' },
      //   { name: 'Arroz', percentage: 65, totalQty: '2' },
      // ]

      onSetCategory(response)

      // response.sales.currentMonthSales = [
      //   {
      //     //@ts-ignore
      //     bsTotal: '1200.8',
      //     usdTotal: '296.80',
      //     date: '2022-10-15',
      //   },
      //   {
      //     //@ts-ignore
      //     bsTotal: '872.4',
      //     usdTotal: '145.40',
      //     date: '2022-10-25',
      //   },
      // ]

      setStats({
        ...response,
        //     netCashFlow: { bs: 20, cop: 30, eur: 10, usd: 15 },
        //     // netCashFlow: { usdAmount: 10, bsAmount: 50 },
        //     // monthIncome: { bsAmount: '50', usdAmount: '10' },
        //     // monthOutflow: { bsAmount: '50', usdAmount: '10' },
        //     accountReceivables: { bsAmount: '90', usdAmount: '20000' },
        //     accountPayables: { bsAmount: '40', usdAmount: '30' },
        //     inventory: {
        //       categories: [
        //         { name: 'Carnes', percentage: 20, totalQty: '10' },
        //         { name: 'Viveres', percentage: 40, totalQty: '20' },
        //         { name: 'Pollos', percentage: 30, totalQty: '5' },
        //       ],
        //       totalInv: '1000',
        //     },
        //     topSoldProducts: {
        //       products: {
        //         allYear: [
        //           { id_item: '10', name: 'fijewoife', totalQuantity: '150' },
        //           { id_item: '9', name: 'fijewoife', totalQuantity: '140' },
        //           { id_item: '8', name: 'fijewoife', totalQuantity: '130' },
        //           { id_item: '7', name: 'fijewoife', totalQuantity: '120' },
        //           { id_item: '6', name: 'fijewoife', totalQuantity: '110' },
        //           { id_item: '5', name: 'efiefioewf', totalQuantity: '100' },
        //           { id_item: '4', name: 'fijewoife', totalQuantity: '90' },
        //           { id_item: '3', name: 'Pan', totalQuantity: '80' },
        //           { id_item: '2', name: 'Trigo', totalQuantity: '70' },
        //           { id_item: '1', name: 'Harina', totalQuantity: '60' },
        //         ],
        //         currentMonth: [
        //           { id_item: '10', name: 'mes 01 producto', totalQuantity: '150' },
        //         ],
        //       },
        //       services: {
        //         allYear: [
        //           { id_service: '1', name: 'Harina', totalQuantity: '60' },
        //           { id_service: '2', name: 'Harina', totalQuantity: '30' },
        //           { id_service: '2', name: 'Harina', totalQuantity: '30' },
        //           { id_service: '2', name: 'Harina', totalQuantity: '30' },
        //           // { id_service: '2', name: 'Harina', totalQuantity: '90' },
        //         ],
        //         currentMonth: [],
        //       },
        //     },
        //     clients: {
        //       totalQty: '50',
        //       newInMonth: '5',
        //     },
        // bankBalance: {
        //   accounts: [
        //     { balance: '1162.40', description: 'Cuenta Egresos' },
        //     { balance: '590.00', description: 'EFECTIVO DOLARES' },
        //     { balance: '900.00', description: 'EFECTIVO Electronico' },
        //   ],
        //   totalBalance: '900.00'
        // },
        //     sales: {
        //       salesByMonth: response.sales.salesByMonth,
        //       currentMonthSales: response.sales.currentMonthSales.map((v) => ({
        //         ...v,
        //         bsTotal: +v.bsTotal,
        //       })),
        //     },
      })
      // setIsFirstRender(true)

    }
  }

  useEffect(() => {
    if (user) {
      getStats()
    }
  }, [user])

  const data = [
    {
      name: 'Page A',
      $USD: 4000,
      prueba: 9000,
    },
    {
      name: 'Page B',
      VEN: 3000,
      prueba: 5000,
    },
  ]

  const colors = ['#021d49', '#0655d6', '#0ad5ed', '#206f78']

  const data02 = [
    {
      name: 'Harina pan',
      percent: 94,
    },
    {
      name: 'Aceite Mazeite',
      percent: 87,
    },
    {
      name: 'Margarina Mavesa',
      percent: 72,
    },
    {
      name: 'Leche en polvo la campesina',
      percent: 66,
    },
    {
      name: 'Jabon de tocador lemon',
      percent: 50,
    },
    {
      name: 'Crema dental colgate',
      percent: 47,
    },
    {
      name: 'Mayonesa Kraft',
      percent: 31,
    },
    {
      name: 'Azucar montalban',
      percent: 27,
    },
    {
      name: 'Vinagre Tiquire',
      percent: 16,
    },
    {
      name: 'Ajo',
      percent: 11,
    },
  ]

  const RenderTooltip = (prop) => {
    // const { x, y, stroke, payload, name, height, index } = prop;
    // const fireOffset = value.toString().length < 5;
    // const offset = fireOffset ? -40 : 5;
    //   return (
    //     <g transform={`translate(${x},${y})`}>
    //     <text x={0} y={0} dy={16} fill="#666">
    //       <tspan textAnchor="middle" x="0">
    //         {name}
    //       </tspan>
    //     </text>
    //   </g>
    // );
    // return (
    //   <g transform={`translate(${x},${y})`}>
    //      <text x={0} y={0} dy={16} fill="#666" transform='rotate(-90)'>
    //        <tspan textAnchor="middle" x="0">
    //          {name}
    //        </tspan>
    //      </text>
    // </g>
    // )
    return (
      <div className="custom-tooltip">
        <p
          className="label"
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: 120,
            color: 'black',
          }}
        >{`${
          isServicesSelected
            ? stats?.topSold?.services?.allYear[prop?.label]?.name
            : stats?.topSold?.products?.allYear[prop?.label]?.name
        }`}</p>
        <p className="label" style={{ color: 'black' }}>{`${
          isServicesSelected
            ? stats?.topSold?.services?.allYear[prop?.label]?.totalQuantity
            : stats?.topSold?.products?.allYear[prop?.label]?.totalQuantity
        }`}</p>
      </div>
    )
  }

  const RenderTooltipSalesPerDay = (prop) => {
    if (stats?.sales.currentMonthSales[prop?.label]?.date) {
      let [year, month, day] = stats?.sales?.currentMonthSales[
        prop?.label
      ]?.date?.split('-') as any
      return (
        <div className="custom-tooltip custom-tooltip-sales">
          <p
            className="label"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 130,
              color: 'black',
            }}
          >{`Fecha: ${day}/${month}/${year}`}</p>
          <p className="label" style={{ color: 'black' }}>{`Monto: ${formatPipe(
            stats?.sales?.currentMonthSales[prop?.label]?.bsTotal + ''
          )}`}</p>
        </div>
      )
    }
    return <></>
  }

  return (
    <>
    <div className='flex justify-between'>
    <h3 className="mb-3">
        Estadísticas de {' '}
        {(infoAccount && infoAccount?.businessName) ||
          infoAccount?.businessSocial ||
          'Tu Negocio'}
      </h3>

      <h3>Zerux (antes Nevula) v2.4</h3>
    </div>
    

      <div className="parent-grid p-3">
        <div
          className="div1 relative shadow-lg overflow-x-auto overflow-y-hidden"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#F6F7FC',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#507CDC',
                }}
                className="mr-3 flex justify-center items-center"
              >
                <div
                  style={{
                    backgroundColor: '#FDFDFD',
                    borderRadius: 20,
                    height: 15,
                    width: 15,
                  }}
                  className="flex justify-center items-center"
                >
                  <IoMdAdd size={20} color={'#507CDC'} />
                </div>
              </div>

              <label className="font-semibold">Ingresos del Mes</label>
            </div>

            {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 0}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(0)} />
            </FloatingMenu> */}
          </div>

          <div className="mt-14">
            <BarChart
              width={320}
              height={200}
              data={[
                {
                  usdAmount: stats?.monthIncome.usd
                    ? +stats?.monthIncome.usd
                    : 0,
                },
                {
                  bsAmount: stats?.monthIncome.bs ? +stats?.monthIncome.bs : 0,
                },
                {
                  eurAmount: stats?.monthIncome?.eur
                    ? +stats?.monthIncome?.eur
                    : 0,
                },
                {
                  copAmount: stats?.monthIncome?.cop
                    ? +stats?.monthIncome?.cop
                    : 0,
                },
              ]}
              barSize={30}
              barGap={-70}
              style={{ marginLeft: '-80px' }}
            >
              {/* <CartesianGrid strokeDasharray="3 3" /> */}
              {/* <XAxis dataKey="name" /> */}
              {/* <Tooltip /> */}

              <Legend
                wrapperStyle={{ left: 220, top: 20, width: 150 }}
                layout="vertical"
                iconSize={10}
                // payload={data.map((item, idx) => ({
                //   id: d,
                //   value: `${item.$USD ? '$USD' : 'VEN'} ${
                //     item?.$USD || item?.VEN
                //   }`,
                // }))}
                payload={[
                  {
                    value: <label style={{fontWeight: 500}}>
                      <strong style={{marginRight: 3, fontWeight: 600}}>
                        $USD
                      </strong>  
                      {stats?.monthIncome.usd
                        ? formatPipe(stats?.monthIncome.usd + '')
                        : formatPipe(0 + '')}
                    </label>,
                    color: '#1400FF',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                      <strong style={{marginRight: 3, fontWeight: 600}}>
                        Bs
                      </strong>  
                      {stats?.monthIncome.bs
                        ? formatPipe(stats?.monthIncome.bs + '')
                        : formatPipe(0 + '')}
                    </label>,
                    color: '#0033A0',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                      <strong style={{marginRight: 3, fontWeight: 600}}>
                        EUR
                      </strong>  
                      {stats?.monthIncome.bs
                        ? formatPipe(stats?.monthIncome.eur + '')
                        : formatPipe(0 + '')}
                    </label>,
                    color: '#1245B1',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      COP
                    </strong>  
                    {stats?.monthIncome.cop
                        ? formatPipe(stats?.monthIncome.cop + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#00C2FF',
                  },
                ]}
              />

              <Bar dataKey="usdAmount" fill="#1400FF" fontWeight="bold" />
              <Bar dataKey="bsAmount" fill="#0033A0" fontWeight="bold" />
              <Bar dataKey="eurAmount" fill="#1245B1" fontWeight="bold" />
              <Bar dataKey="copAmount" fill="#00C2FF" fontWeight="bold" />
            </BarChart>
          </div>

          {/* <div
            className="flex justify-end absolute items-center"
            style={{ bottom: 0, padding: 'inherit', right: 0 }}
          >
            <IoCalendar className="text-primary mr-3" />
            <label className="text-xs">Filtrado Mes: Julio 2022</label>
          </div> */}
        </div>

        <div
          className="div2 relative shadow-lg overflow-x-auto overflow-y-hidden"
          style={{ backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',   
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0, }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#507CDC',
                }}
                className="mr-3 flex justify-center items-center"
              >
                <div
                  style={{
                    backgroundColor: '#FDFDFD',
                    borderRadius: 20,
                    height: 15,
                    width: 15,
                  }}
                  className="flex justify-center items-center"
                >
                  <FiMinus size={20} color={'#507CDC'} />
                </div>
              </div>

              <label className="font-semibold">Egresos del Mes</label>
            </div>

            {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 1}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(1)} />
            </FloatingMenu> */}
          </div>

          <div className="mt-14">
            <BarChart
              width={320}
              height={200}
              data={[
                {
                  usdAmount: stats?.monthOutflow.usd
                    ? +stats?.monthOutflow.usd
                    : 0,
                },
                {
                  bsAmount: stats?.monthOutflow.bs
                    ? +stats?.monthOutflow.bs
                    : 0,
                },
                {
                  eurAmount: stats?.monthOutflow?.eur
                    ? +stats?.monthOutflow?.eur
                    : 0,
                },
                {
                  copAmount: stats?.monthOutflow?.cop
                    ? +stats?.monthOutflow?.cop
                    : 0,
                },
              ]}
              barSize={30}
              barGap={-70}
              style={{ marginLeft: '-80px' }}
            >
              {/* <CartesianGrid strokeDasharray="3 3" /> */}
              {/* <XAxis dataKey="name" /> */}
              {/* <Tooltip /> */}
              <Legend
                wrapperStyle={{ left: 220, top: 20, width: 150 }}
                layout="vertical"
                iconSize={10}
                payload={[
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      $USD
                    </strong>  
                    {stats?.monthOutflow.usd
                        ? formatPipe(stats?.monthOutflow.usd + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#1400FF',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      Bs
                    </strong>  
                    {stats?.monthOutflow.bs
                        ? formatPipe(stats?.monthOutflow.bs + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#0033A0',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      EUR
                    </strong>  
                    {stats?.monthOutflow.bs
                        ? formatPipe(stats?.monthIncome.eur + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#1245B1',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      COP
                    </strong>  
                    {stats?.monthOutflow.cop
                        ? formatPipe(stats?.monthIncome.cop + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#00C2FF',
                  },
                ]}
              />
              <Bar dataKey="usdAmount" fill="#1400FF" fontWeight="bold" />
              <Bar dataKey="bsAmount" fill="#0033A0" fontWeight="bold" />
              <Bar dataKey="eurAmount" fill="#1245B1" fontWeight="bold" />
              <Bar dataKey="copAmount" fill="#00C2FF" fontWeight="bold" />
            </BarChart>
          </div>

          {/* <div
            className="flex justify-end absolute items-center"
            style={{ bottom: 0, padding: 'inherit', right: 0 }}
          >
            <IoCalendar className="text-primary mr-3" />
            <label className="text-xs">Filtrado Mes: Julio 2022</label>
          </div> */}
        </div>

        {/* <div
          className="div3 relative shadow-lg overflow-x-auto overflow-y-hidden"
          style={{
            backgroundColor: theme === 'dark' ? '#0C0C0C' : '#0464D7',
            borderColor: theme === 'dark' ? '#006AEA' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#FFFFFF',
                }}
                className="mr-3 flex justify-center items-center"
              >
                <BsGraphUp size={20} color={'#507CDC'} />
              </div>

              <label className="font-semibold text-white">Flujo de Caja</label>
            </div>
          </div>

          <div className="mt-14">
            <BarChart
              width={320}
              height={200}
              data={[
                {
                  usdAmount: stats?.netCashFlow.usd
                    ? +stats?.netCashFlow.usd
                    : 0,
                },
                {
                  bsAmount: stats?.netCashFlow?.bs ? +stats?.netCashFlow.bs : 0,
                },
                {
                  eurAmount: stats?.netCashFlow?.eur
                    ? +stats?.netCashFlow?.eur
                    : 0,
                },
                {
                  copAmount: stats?.netCashFlow?.cop
                    ? +stats?.netCashFlow?.cop
                    : 0,
                },
              ]}
              barSize={30}
              barGap={-70}
              style={{ marginLeft: '-80px' }}
            >
              <Legend
                wrapperStyle={{ left: 220, top: 20, width: 150 }}
                layout="vertical"
                iconSize={10}
                payload={[
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      USD
                    </strong>  
                    {stats?.netCashFlow.usd
                        ? formatPipe(stats?.netCashFlow.usd + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#E4E4E4',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      Bs
                    </strong>  
                    {stats?.netCashFlow.bs
                        ? formatPipe(stats?.netCashFlow.bs + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#E4E4E4',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      EUR
                    </strong>  
                    {stats?.netCashFlow.bs
                        ? formatPipe(stats?.netCashFlow.eur + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#E4E4E4',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      COP
                    </strong>  
                    {stats?.netCashFlow.cop
                        ? formatPipe(stats?.netCashFlow.cop + '')
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#E4E4E4',
                  },
                ]}
              />
              <Bar dataKey="usdAmount" fill="#102F72" fontWeight="bold" />
              <Bar dataKey="bsAmount" fill="#3F0BC8" fontWeight="bold" />
              <Bar dataKey="eurAmount" fill="#E4E4E4" fontWeight="bold" />
              <Bar dataKey="copAmount" fill="#12ACEE" fontWeight="bold" />
            </BarChart>
          </div>
        </div> */}

        <div
          className="div6 relative shadow-lg overflow-x-auto overflow-y-hidden"
          // style={{ backgroundColor: '#FFFFFF' }}
          style={{ backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',   
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0, }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#FFFFFF',
                }}
                className="mr-3 flex justify-center items-center shadow-lg"
              >
                <FaShoppingBag size={20} color={'#507CDC'} />
              </div>

              <label className="font-semibold">Cuentas por pagar</label>
            </div>

            {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 6}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(6)} />
            </FloatingMenu> */}
          </div>

          <div className="mt-10">
            <BarChart
              width={170}
              height={200}
              data={[
                {
                  usdAmount: stats?.accountPayables.usdAmount
                    ? +stats?.accountPayables.usdAmount
                    : 0,
                },
                {
                  bsAmount: stats?.accountPayables.bsAmount
                    ? +stats?.accountPayables.bsAmount
                    : 0,
                },
              ]}
              barSize={30}
              barGap={-70}
              style={{ marginLeft: '-45px' }}
            >
              {/* <CartesianGrid strokeDasharray="3 3" /> */}
              {/* <XAxis dataKey="name" /> */}
              {/* <Tooltip /> */}
              <Legend
                wrapperStyle={{ left: 160, top: 40, width: 180 }}
                layout="vertical"
                iconSize={10}
                payload={[
                  {   
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      $USD
                    </strong>  
                    {stats?.accountPayables.usdAmount
                        ? formatPipe(stats?.accountPayables.usdAmount)
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#062F97',
                  },
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      Bs
                    </strong>  
                    {stats?.accountPayables.bsAmount
                        ? formatPipe(stats?.accountPayables.bsAmount)
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#507CDC',
                  },
                ]}
              />
              <Bar dataKey="usdAmount" fill="#062F97" fontWeight="bold" />
              <Bar dataKey="bsAmount" fill="#507CDC" fontWeight="bold" />
            </BarChart>
          </div>
        </div>

        <div
          className="div4 overflow-x-auto overflow-y-hidden shadow-lg"
          // style={{ backgroundColor: '#F6F7FC' }}
          style={{ backgroundColor: theme === 'dark' ? '#1D1D1D' : '#F6F7FC',   
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0, }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#2D5DC3',
                }}
                className="mr-3 flex justify-center items-center shadow-lg"
              >
                <BsHandbagFill size={17} className="text-white" />
              </div>

              <label className="font-semibold">
                Venta por {cardStates[4] === 'day' ? 'día' : 'mes'}
              </label>
            </div>

            <FloatingMenu
              options={{
                onDay: () => {
                  onClick(4, 'day')
                },
                onMonth: () => {
                  onClick(4, 'month')
                },
              }}
              visible={selectedCard === 4}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots
                className="cursor-pointer"
                onClick={() => {
                  // onClick(4)
                  setSelectedCard(4)
                  onChangeSelected(4)
                }}
              />
            </FloatingMenu>
          </div>

          <div className="mt-10 ml-10">
            {cardStates[4] === 'day' && (
              <LineChart
                width={300}
                height={180}
                data={stats?.sales.currentMonthSales.map((v) => ({
                  bsTotal: +v.bsTotal,
                  usdTotal: +v.usdTotal,
                }))}
                style={{ marginLeft: '-60px' }}
              >
                <XAxis tick={false} />
                <YAxis />
                {/* <Tooltip /> */}
                <Tooltip content={<RenderTooltipSalesPerDay />} />

                {/* <Legend /> */}
                <Line type="monotone" dataKey="bsTotal" stroke="#8884d8" />
                {/* <Line type="monotone" dataKey="uv" stroke="#82ca9d" /> */}
              </LineChart>
            )}

            {cardStates[4] === 'month' && (
              <ComposedChart
                width={300}
                height={180}
                data={salesInformation}
                barSize={30}
                barGap={-40}
                style={{ marginLeft: '-60px' }}
              >
                <XAxis dataKey="month" />
                <YAxis />
                {/* <CartesianGrid stroke="#f5f5f5" /> */}
                {/* <Area type="monotone" dataKey="prueba" fill="#8884d8" stroke="#8884d8" /> */}
                {/* <Bar dataKey="pv" barSize={20} fill="#413ea0" /> */}

                {salesInformation.map((sale, i) => (
                  <Bar
                    dataKey={sale.month}
                    fill={i % 2 === 0 ? '#062F97' : '#507CDC'}
                    fontWeight="bold"
                  />
                ))}
                {/* <Bar dataKey="Febrero" fill="#507CDC" fontWeight="bold" />
              <Bar dataKey="Marzo" fill="#062F97" fontWeight="bold" />
              <Bar dataKey="Abril" fill="#507CDC" fontWeight="bold" />
              <Bar dataKey="Mayo" fill="#062F97" fontWeight="bold" />
              <Bar dataKey="Junio" fill="#507CDC" fontWeight="bold" />
              <Bar dataKey="Julio" fill="#062F97" fontWeight="bold" />
              <Bar dataKey="Agosto" fill="#507CDC" fontWeight="bold" />
              <Bar dataKey="Septiembre" fill="#062F97" fontWeight="bold" />
              <Bar dataKey="Octubre" fill="#507CDC" fontWeight="bold" />
              <Bar dataKey="Noviembre" fill="#062F97" fontWeight="bold" />
              <Bar dataKey="Diciembre" fill="#507CDC" fontWeight="bold" /> */}

                {/* <Bar dataKey="Julio" fill="#062F97" fontWeight="bold" />
              <Bar dataKey="Octubre" fill="#507CDC" fontWeight="bold" /> */}
                {/* <Line
                type="monotone"
                dataKey="prueba"
                stroke="#31DA16"
                strokeDasharray={'4'}
              /> */}
              </ComposedChart>
            )}
            {/**  Hacer condicional acá para cuando selecciona mes o día. */}
          </div>
        </div>

        <div
          className="div5 shadow-lg overflow-x-auto overflow-y-hidden"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#F6F7FC',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">

              <div
                style={{
                  backgroundColor: '#FFFFFF',
                  borderRadius: 20,
                  height: 28,
                  width: 28,
                }}
                className="flex justify-center items-center shadow-lg mr-3"
              >
                <HiShoppingBag size={20} color={'#507CDC'} />
              </div>

              <label className="font-semibold">Cuentas por cobrar</label>
            </div>

            {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 5}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(5)} />
            </FloatingMenu> */}
          </div>

          <div className="mt-10">
            <BarChart
              width={170}
              height={200}
              data={[
                {
                  usdAmount: stats?.accountReceivables.usdAmount
                    ? +stats?.accountReceivables.usdAmount
                    : 0,
                },
                {
                  bsAmount: stats?.accountReceivables.bsAmount
                    ? +stats?.accountReceivables.bsAmount
                    : 0,
                },
              ]}
              barSize={30}
              barGap={-70}
              style={{ marginLeft: '-45px' }}
            >
              {/* <CartesianGrid strokeDasharray="3 3" /> */}
              {/* <XAxis dataKey="name" /> */}
              {/* <Tooltip /> */}
              <Legend
                wrapperStyle={{ left: 160, top: 40, width: 180 }}
                layout="vertical"
                iconSize={10}
                payload={[
                  {
                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      $USD
                    </strong>  
                    {stats?.accountReceivables.usdAmount
                        ? formatPipe(stats?.accountReceivables.usdAmount, false, 2, -9999999999)
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#062F97',
                  },
                  {

                    value: <label style={{fontWeight: 500}}>
                    <strong style={{marginRight: 3, fontWeight: 600}}>
                      Bs
                    </strong>  
                    {stats?.accountReceivables.bsAmount
                        ? formatPipe(stats?.accountReceivables.bsAmount, false, 2, -9999999999)
                        : formatPipe(0 + '')}
                  </label>,
                    color: '#507CDC',
                  },
                ]}
              />
              <Bar dataKey="usdAmount" fill="#507CDC" fontWeight="bold" />
              <Bar dataKey="bsAmount" fill="#062F97" fontWeight="bold" />
            </BarChart>
          </div>
        </div>

        <div
          className="div7 shadow-lg"
          // style={{ backgroundColor: '#FFFFFF' }}
          style={{ backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',   
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0, }}
        >
          <div className="flex justify-between w-full">
            <div className="flex items-center mb-3">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#FFFFFF',
                }}
                className="mr-3 flex justify-center items-center shadow-lg"
              >
                <IoWallet size={20} color={'#507CDC'} />
              </div>

              <label className="font-semibold mr-3">Saldos en Banco</label>

              {windowSize.innerWidth <= 1500 &&
                stats &&
                stats?.bankBalance?.accounts.length > 1 && (
                  <h3
                    className="font-semibold"
                    style={{ color: theme === 'dark' ? 'white' : '#244791' }}
                  >
                    Saldo total de las cuentas:{' '}
                    {formatPipe(stats?.bankBalance?.totalBalance + '', false, 2, -99999999999)}
                  </h3>
                )}
            </div>

            {/* <FloatingMenu
              options={{
                onWatchAccounts: () => {
                  setShowAccounts(true)
                },
              }}
              visible={selectedCard === 3}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots
                className="cursor-pointer"
                onClick={() => setSelectedCard(3)}
              />
            </FloatingMenu> */}
          </div>

          <div
            className='relative'
            style={{
              height: `calc(100% - ${
                windowSize.innerWidth <= 1500 ? '30px' : '60px'
              })`,
              display: 'flex',
              flexDirection: windowSize.innerWidth <= 1500 ? 'row' : 'column',
            }}
            ref={div7RefContainer}
          >
            {/* {windowSize.innerWidth > 1500 && (
              <h3
                className="mb-3 font-semibold mt-5"
                style={{ color: theme === 'dark' ? 'white' : '#244791' }}
              >
                Saldo total de las cuentas: Bs {formatPipe(stats?.bankBalance?.totalBalance + '', false, 2, -99999999999)}
              </h3>
            )} */}

            {stats?.bankBalance.accounts
              .slice(0, windowSize.innerWidth <= 1500 ? 3 : 2)
              .map((v) => (
                <div
                  className='shadow-md'
                  style={{
                    height:
                      windowSize.innerWidth <= 1500
                        ? '100%'
                        : div7RefContainer?.current?.offsetHeight / 3 -
                          div7RefContainer?.current?.offsetHeight * 0.02,
                    width: windowSize.innerWidth <= 1500 ? '90%' : '100%',
                    backgroundColor: theme === 'dark' ? '#222222' : '',
                    marginTop:
                      window.innerWidth <= 1500
                        ? 0
                        : div7RefContainer?.current?.offsetHeight * 0.03,
                    borderRadius: 5,
                    padding: 20,
                    overflow: windowSize.innerWidth <= 1500 ? 'auto' : 'hidden',
                    marginRight: windowSize.innerWidth <= 1500 ? 20 : 0,
                    borderWidth: theme === 'dark' ? 1 : 0,
                    borderColor: theme === 'dark' ? '#2D2D2D' : '',
                    
                  }}
                >
                  <h3
                    className="mb-3 font-semibold truncate"
                    style={{ color: theme === 'dark' ? '#0275FF' : '#244791' }}
                  >
                    {v.description}
                  </h3>

                  <label className="font-medium" style={{color: theme === 'dark' ? '#B1E203' : '#244791'}}>Saldo disponible</label>

                  <h1 className="text-center text-primary mt-3 truncate" style={{color: theme === 'dark' ? '#FFFFFF' : '#244791'}}>
                    {`${getDenomination(v?.idCurrency)} ${formatPipe(v.balance, false, 2, -99999999999)}`}
                  </h1>
                </div>
              ))}

              <div className='absolute bottom-0 flex justify-center w-full'>
                <label className='cursor-pointer' style={{color: "#0464D7", fontWeight: 500}} onClick={() => setShowAccounts(true)}>Mostrar mas</label>
              </div>

            {/* <div
              style={{
                height:
                  windowSize.innerWidth <= 1500
                    ? '100%'
                    : div7RefContainer?.current?.offsetHeight / 3 -
                      div7RefContainer?.current?.offsetHeight * 0.02,
                width: windowSize.innerWidth <= 1500 ? '90%' : '100%',
                backgroundColor: '#EFEFEF',
                marginTop:
                  window.innerWidth <= 1500
                    ? 0
                    : div7RefContainer?.current?.offsetHeight * 0.03,
                borderRadius: 5,
                padding: 20,
                overflow: windowSize.innerWidth <= 1500 ? 'auto' : 'hidden',
                marginRight: windowSize.innerWidth <= 1500 ? 20 : 0,
              }}
            >
              <h3 className="mb-3 font-semibold" style={{ color: '#244791' }}>
                Cuenta pago móvil
              </h3>

              <label className="font-medium">Saldo disponible</label>

              <h1 className="text-center text-primary mt-3">8.254</h1>
            </div> */}

            {/* <div
              style={{
                height:
                  windowSize.innerWidth <= 1500
                    ? '100%'
                    : div7RefContainer?.current?.offsetHeight / 3 -
                      div7RefContainer?.current?.offsetHeight * 0.02,
                width: windowSize.innerWidth <= 1500 ? '90%' : '100%',
                backgroundColor: '#EFEFEF',
                marginTop:
                  window.innerWidth <= 1500
                    ? 0
                    : div7RefContainer?.current?.offsetHeight * 0.03,
                borderRadius: 5,
                padding: 20,
                overflow: windowSize.innerWidth <= 1500 ? 'auto' : 'hidden',
                marginRight: windowSize.innerWidth <= 1500 ? 20 : 0,
              }}
            >
              <h3 className="mb-3 font-semibold" style={{ color: '#244791' }}>
                Cuenta punto de venta
              </h3>

              <label className="font-medium">Saldo disponible</label>

              <h1 className="text-center text-primary mt-3">8.254</h1>
            </div> */}
          </div>
        </div>

        <div
          className="div8 shadow-lg relative"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#FFFFFF',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
          ref={div8Ref}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#507CDC',
                }}
                className="mr-3 flex justify-center items-center"
              >
                <IoBarChartSharp size={20} color={'white'} />
              </div>

              <label className="font-semibold">Productos mas vendidos</label>
            </div>

            <FloatingMenu
              options={{
                onMonth: () => {
                  onClick(7, 'month')
                },
                onAnnual: () => {
                  onClick(7, 'annual')
                },
              }}
              visible={selectedCard === 7}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots
                className="cursor-pointer"
                onClick={() => {
                  setSelectedCard(7)
                  onChangeSelected(7)
                }}
              />
            </FloatingMenu>
          </div>

          <div
          // className="absolute"
          // style={{ bottom: 0, padding: 'inherit', right: 0 }}
          >
            <div className="relative">
              <ResponsiveContainer
                width={`${
                  // Math.pow(
                  //   (isServicesSelected ? stats?.topSoldProducts?.services?.allYear?.length || 10 :  stats?.topSoldProducts?.products?.allYear?.length || 10),
                  //   2
                  // ) - 10
                  isServicesSelected
                    ? (stats?.topSold?.services?.[
                        cardStates[7] === 'month' ? 'currentMonth' : 'allYear'
                      ]?.length || 10) *
                        10 -
                      5
                    : (stats?.topSold?.products?.[
                        cardStates[7] === 'month' ? 'currentMonth' : 'allYear'
                      ]?.length || 10) *
                        10 -
                      5
                }%`}
                height={div8Ref?.current?.offsetHeight - 100}
                className="absolute mt-5"
              >
                <BarChart
                  // width={div8Ref?.current?.offsetWidth}
                  // height={div8Ref?.current?.offsetHeight}
                  data={
                    isServicesSelected
                      ? stats?.topSold?.services?.[
                          cardStates[7] === 'month' ? 'currentMonth' : 'allYear'
                        ].map((v) => ({
                          ...v,
                          totalQuantity: +v.totalQuantity,
                        }))
                      : stats?.topSold?.products?.[
                          cardStates[7] === 'month' ? 'currentMonth' : 'allYear'
                        ].map((v) => ({
                          ...v,
                          totalQuantity: +v.totalQuantity,
                        }))
                  }
                  barSize={30}
                  barGap={-70}
                  // style={{ position: 'absolute' }}
                >
                  {/* <Bar dataKey={'percent'} fill={'#507CDC'} fontWeight="bold" label={{position: 'end', fill: 'white'}} > */}
                  <Tooltip content={<RenderTooltip />} />
                  <Bar
                    dataKey={'totalQuantity'}
                    fill={theme === 'dark' ? '#006AEA' : '#507CDC'}
                    // label={{ position: "bottom", fill: "black", content: renderContent }}
                    name="name"
                  />

                  {/* <LabelList
                angle={-90}
                content={renderContent}
                /> */}
                  {/* </Bar> */}

                  {/* <LabelList 
                  dataKey={'name'}
                  position="top"
                  angle={270}
                  offset={25}
                  fill='black'
                /> */}
                  {/* { data02.map(v => <Cell />) }  */}
                </BarChart>
              </ResponsiveContainer>

              <div
                className="absolute flex flex-col w-full"
                style={{ alignItems: 'flex-end', width: '97%' }}
              >
                <div className="flex mb-5">
                  <label className="mr-3">Productos</label>
                  <Switch
                    forForm={true}
                    onChange={(value) => setIsServicesSelected(value)}
                  />
                  <label>Servicios</label>
                </div>

                <div>
                  <div
                    className="flex justify-end items-center"
                    style={{ bottom: 0, padding: 'inherit', right: 0 }}
                  >
                    <IoCalendar className="text-primary mr-3" />
                    <label className="text-xs">{`Filtrado por ${
                      cardStates[7] === 'month' ? 'mes' : 'año'
                    }`}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="div9 shadow-lg"
          // style={{ backgroundColor: '#F6F7FC' }}
          style={{ backgroundColor: theme === 'dark' ? '#1D1D1D' : '#F6F7FC',   
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0, }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#507CDC',
                }}
                className="mr-3 flex justify-center items-center"
              >
                <HiAdjustments size={20} color={'white'} />
              </div>

              <label className="font-semibold">
                Porcentaje de ganancia bruta
              </label>
            </div>

            <FloatingMenu
              options={{
                onDay: () => {
                  onClick(8, 'day')
                },
                onAnnual: () => {
                  onClick(8, 'annual')
                },
              }}
              visible={selectedCard === 8}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots
                className="cursor-pointer"
                onClick={() => {
                  setSelectedCard(8)
                  onChangeSelected(8)
                }}
              />
            </FloatingMenu>
          </div>

          <h1 className="text-center mt-10 text-primary">
            {cardStates[8] === 'day'
              ? stats?.grossMargin?.monthGrossMargin
              : stats?.grossMargin?.annualGrossMargin}
            %
          </h1>
        </div>

        <div
          className="div10 relative shadow-lg truncate"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#F6F7FC',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: 'white',
                }}
                className="mr-3 flex justify-center items-center shadow-lg"
              >
                <BsPersonFill size={20} className="text-primary" />
              </div>

              <label className="font-semibold">Clientes</label>
            </div>
            {/* 
            <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 9}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots
                className="cursor-pointer"
                onClick={() => setSelectedCard(9)}
              />
            </FloatingMenu> */}
          </div>

          <div className="flex flex-col items-center">
            <div
              className="flex justify-center mt-3"
              style={{ maxWidth: '70%' }}
            >
              <BsPersonFill className="text-primary mr-2" size={30} />
              <h1 className="text-primary truncate">
                {stats?.clients?.totalQty}
              </h1>
            </div>
            <label>Cantidad de clientes</label>
          </div>

          <div
            className="flex absolute items-center"
            style={{ bottom: 0, padding: 'inherit', paddingLeft: 0 }}
          >
            <IoPersonAddSharp className="mr-2 text-primary" />
            <label>
              Clientes nuevos del mes:{' '}
              <strong className="text-primary">
                {stats?.clients?.newInMonth}
              </strong>
            </label>
          </div>
        </div>

        <div
          className="div3 shadow-lg"
          style={{
            backgroundColor: theme === 'dark' ? '#1D1D1D' : '#0464D7',
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0,
          }}
        >
          {/* <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: 'white',
                }}
                className="mr-3 flex justify-center items-center shadow-lg"
              >
                <CgFileDocument size={20} className="text-primary" />
              </div>

              <label className="font-semibold">Facturación</label>
            </div>

            <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={false}
              onClose={() => {}}
            >
              <BsThreeDots className="cursor-pointer" />
            </FloatingMenu>
          </div>


            </div>   */}

          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: 'white',
                }}
                className="mr-3 flex justify-center items-center shadow-lg"
              >
                <HiDocumentText size={20} className="text-primary" />
              </div>

              <label className="font-semibold text-white">
                Facturación diaria
              </label>
            </div>

            {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 10}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer text-white" onClick={() => setSelectedCard(10)} />
            </FloatingMenu> */}
          </div>

          <div
            className="mt-5"
            style={{
              height: 'calc(100% - 20px - 1.25rem)',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-evenly',
            }}
          >
            <div className="flex justify-between">
              <div style={{ width: 100 }} className="truncate">
                <div className='flex flex-row items-center'>
                <BiMoney className='text-white' size={20} />
                <label className="font-semibold text-white" style={{fontSize: 15, marginLeft: 2}}>Bs Efectivo</label>
                </div>
                <h1 className="text-white text-2xl">
                  {stats?.dayBilling?.bsCash
                    ? formatPipe(stats?.dayBilling?.bsCash)
                    : formatPipe(0 + '')}
                </h1>
              </div>

              <div style={{ width: 120 }} className="truncate">
                <div className='flex flex-row items-center'>
                  <BsCashCoin className='text-white' size={16} />
                <label className="font-semibold text-white" style={{fontSize: 15, marginLeft: 3}}>
                  USD Efectivo
                </label>
                </div>
                <h1 className="text-white text-2xl">
                  {stats?.dayBilling?.usdCash
                    ? formatPipe(stats?.dayBilling?.usdCash)
                    : formatPipe(0 + '')}
                </h1>
              </div>
            </div>

            <div className="flex justify-between">
              <div style={{ width: 100 }} className="truncate">
                <div className='flex flex-row items-center'>
                <IoCashSharp className='text-white' size={16} />
                <label className="font-semibold text-white" style={{fontSize: 15, marginLeft: 3}}>Bs Digital</label>
                </div>
                <h1 className="text-white text-2xl">
                  {stats?.dayBilling?.bsDigital
                    ? formatPipe(stats?.dayBilling?.bsDigital)
                    : formatPipe(0 + '')}
                </h1>
              </div>

              <div style={{ width: 120 }} className="truncate">
                <div className='flex flex-row items-center'>
                  <FaCashRegister className='text-white' size={15} />
                <label className="font-semibold text-white" style={{fontSize: 15, marginLeft: 3}}> 
                  USD Digital
                </label>
                </div>
                <h1 className="text-white text-2xl">
                  {stats?.dayBilling?.usdDigital
                    ? formatPipe(stats?.dayBilling?.usdDigital)
                    : formatPipe(0 + '')}
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div
          className="div11 shadow-lg"
          // style={{ backgroundColor: '#F6F7FC' }}
          style={{ backgroundColor: theme === 'dark' ? '#1D1D1D' : '#F6F7FC',   
            borderColor: theme === 'dark' ? '#2D2D2D' : '',
            borderWidth: theme === 'dark' ? 1 : 0, }}
        >
          <div className="flex justify-between w-full">
            <div className="flex">
              <div
                style={{
                  height: 28,
                  width: 28,
                  borderRadius: 20,
                  backgroundColor: '#2D5DC3',
                }}
                className="mr-3 flex justify-center items-center shadow-lg"
              >
                <IoDocuments size={20} className="text-white" />
              </div>

              <label className="font-semibold">Inventario</label>
            </div>

            {/* <FloatingMenu
              options={{ onEdit: () => {} }}
              visible={selectedCard === 12}
              onClose={() => setSelectedCard(null)}
            >
              <BsThreeDots className="cursor-pointer" onClick={() => setSelectedCard(12)} />
            </FloatingMenu> */}
          </div>

          <div className="flex items-center overflow-auto">
            <PieChart
              width={140}
              height={windowSize.innerWidth <= 1500 ? 120 : 200}
            >
              {/* <defs>
                {colorsGradient.map((data, index) => (
                  <linearGradient id={`myGradient${index}`}>
                    <stop offset="0%" stopColor={data.start} />
                    <stop offset="100%" stopColor={data.end} />
                  </linearGradient>
                ))}
              </defs> */}
              <Pie
                data={category}
                dataKey="percentage"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={60}
                paddingAngle={5}
                cornerRadius={20}
                rotate={70}
              >
                {category.map((v, index) => (
                  <Cell fill={colors[index]} />
                ))}
              </Pie>
            </PieChart>

            <div>
              {category.map((cat, idx) => (
                <div className="flex items-center">
                  <AiFillCheckCircle color={colors[idx]} className="mr-3" />
                  <div
                    style={{
                      maxWidth: 120,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    <label className="mr-2">{cat.name}</label>
                  </div>
                  <label className="text-primary font-semibold">
                    {toFixed(cat.percentage, 2)}%
                  </label>
                </div>
              ))}

              {/* <div className="flex items-center">
                <AiFillCheckCircle className="text-primary mr-2" />
                <label className="mr-2">Carniceria</label>
                <label className="text-primary font-semibold">25%</label>
              </div>

              <div className="flex items-center">
                <AiFillCheckCircle className="text-primary mr-2" />
                <label className="mr-2">Embutidos</label>
                <label className="text-primary font-semibold">25%</label>
              </div>

              <div className="flex items-center">
                <AiFillCheckCircle className="text-primary mr-2" />
                <label className="mr-2">Víveres</label>
                <label className="text-primary font-semibold">25%</label>
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <Modal
        display={showAccounts}
        onClose={() => {
          setShowAccounts(false)
        }}
      >
        <div className="parent-account">
          {stats?.bankBalance.accounts.map((v) => (
            <div
              style={{
                height: 170,
                width: '100%',
                backgroundColor: theme === 'dark' ? '#101316' : '#EFEFEF',
                borderRadius: 5,
                padding: 20,
                // overflow: windowSize.innerWidth <= 1500 ? 'auto' : 'hidden',
                // marginRight: windowSize.innerWidth <= 1500 ? 20 : 0,
              }}
              className="shadow-lg"
            >
              <h3
                className="mb-3 font-semibold"
                style={{ color: theme === 'dark' ? '#0275FF' : '#244791' }}
              >
                {v.description}
              </h3>

              <label className="font-medium">Saldo disponible</label>

              <h1 className="text-center text-primary mt-3 truncate">
                { `${getDenomination(v?.idCurrency)} ${formatPipe(v.balance, false, 2, -99999999999)}`}
              </h1>
            </div>
          ))}
        </div>
      </Modal>
    </>
  )
}

export interface IStats {
  accountPayables: {
    bsAmount: string
    usdAmount: string
  }
  accountReceivables: {
    bsAmount: string
    usdAmount: string
  }
  bankBalance: {
    accounts: { balance: string; description: string; idCurrency: string }[]
    totalBalance: string
  }
  // clientQty: string
  clients: {
    totalQty: string
    newInMonth: string
  }
  dayBilling: {
    bsCash: string
    bsDigital: string
    copCash: string
    eurCash: string
    usdCash: string
    usdDigital: string
  }
  grossMargin: {
    annualGrossMargin: string
    monthGrossMargin: string
  }
  inventory: {
    categories: { name: string; percentage: number; totalQty: string }[]
    totalInv: string
  }
  monthIncome: {
    bs: number
    usd: number
    eur: number
    cop: number
  }
  monthOutflow: {
    bs: number
    usd: number
    eur: number
    cop: number
  }
  netCashFlow: {
    bs: number
    usd: number
    eur: number
    cop: number
  }
  sales: {
    currentMonthSales: { bsTotal: number; usdTotal: string; date: string }[]
    salesByMonth: { bsTotal: string; month: number; usdTotal: string }[]
  }
  topSold: {
    products: {
      allYear: { id_item: string; name: string; totalQuantity: string }[]
      currentMonth: any[]
    }
    services: {
      allYear: { id_service: string; name: string; totalQuantity: string }[]
      currentMonth: any[]
    }
  }
}

export default DashboardStats
